module.exports = __webpack_public_path__ + "static/img/301.png";